// extracted by mini-css-extract-plugin
export var labelWrapper = "_9r-0";